import React from "react";

const BulletItem = ({ children }) => <li>{children}</li>;

const schemeDetails = [
  {
    label: "Term Loan Scheme:",
    text: "Under this scheme, credit is extended for financing economically viable income generation ventures. Loan of upto Rs. 20 lacs under Credit Line-1 and upto Rs. 30 lacs under Credit line -2 is extended to beneficiaries at 6% p.a respectively. Further, concession of 2% is extended to women beneficiaries under Credit Line-2.",
  },
  {
    label: "Education Loan Scheme:",
    text: "Under this scheme, loan is available for job oriented 'technical and professional courses' of durations not exceeding five years. Loan of upto Rs. 20 lacs for domestic courses & Rs. 30 lacs for courses abroad under Credit Line-1 and Credit line -2 is extended to beneficiaries at 3% p.a. & 8% p.a respectively. Further, concession of 3% is extended to women beneficiaries under Credit Line-2.",
  },
  {
    label: "Micro-Finance Scheme:",
    text: "Under this Scheme, credit is extended to the members of the Self Help Groups (SHGs), predominantly comprising of the minority women scattered in remote villages and urban slums, who are not able to take advantage of the formal banking credit. Under the scheme, an amount of Rs. 1 lacs under credit Line-1 & upto Rs. 1.5 lacs under Credit Line-2 is extended to each member of SHG at interest rate of 7% & 10% respectively. Concession of 2% is extended to women beneficiaries under Credit Line-2.",
  },
  {
    label: "Virasat Scheme:",
    text: "This scheme is part of the Term Loan scheme and is implemented with the objective to meet Working Capital and Fixed Capital for purchase of equipment/tools/machineries/raw material. Maximum loan of upto Rs.10.00 lacs can be availed under Credit Line-1 & 2. Simple interest of 5% p.a. is charged under Credit Line-1 and at 6% p.a. from Male Artisan under Credit line- 2. Concession of 1% is provided to Female Artisan under both the Credit Lines.",
  },
];

const textCellClass =
  "border border-[#bcd7ff] px-3 py-3 text-center align-middle text-[12px] font-medium leading-[1.45] text-[#001b3d]";
const labelCellClass =
  "border border-[#bcd7ff] bg-white px-3 py-3 text-center align-middle text-[12px] font-bold leading-[1.35] text-[#001b3d]";
const headerCellClass =
  "border border-[#bcd7ff] bg-[#dcecff] px-3 py-3 text-center align-middle text-[12px] font-bold uppercase leading-[1.25] text-[#15356b]";

const NmdfcSchemesContent = () => {
  return (
    <div className="space-y-6 text-[#001b3d]">
      <section className="space-y-3">
        <h2 className="text-[20px] font-bold text-[#123b73]">
          NMDFC Schemes
        </h2>
        <p className="text-[15px] leading-[1.7] text-[#00152f]">
          National Minorities Development & Finance Corporation is a Govt.
          Company under section 8 of Companies Act 2013, under the
          administrative control of Ministry of Minority Affairs, Government of
          India. The Corporation has been set up to promote economic development
          for the benefit of "Backward Sections" amongst the Minority
          Communities i.e. Muslims, Christians, Sikhs, Buddhists, Parsis &
          Jains, preference being given to the occupational group and women.
        </p>
        <p className="text-[15px] leading-[1.7] text-[#00152f]">
          Based on annual income, target group bifurcated into two credit lines
          as follows:
        </p>
        <ul className="ml-5 list-disc space-y-1.5 text-[14px] leading-[1.65] text-[#00152f] marker:text-[#123b73]">
          <BulletItem>
            <strong>Credit Line-1:</strong>{" "}
            The benefits are available for persons with annual family income of upto Rs.3.00 lakh.
          </BulletItem>

          <BulletItem>
            <strong>Credit Line-2:</strong>{" "}
            The benefits are available to persons with annual family income of upto Rs. 8.00 lakh.
          </BulletItem>
        </ul>
        <p className="text-[15px] leading-[1.7] text-[#00152f]">
          NMDFC implements its schemes & programs through State Channelizing
          Agencies (SCAs) nominated by the respective State Governments &
          Banking Partners.
        </p>
      </section>

      <section className="space-y-3">
        <h3 className="text-[18px] font-bold text-[#123b73]">
          Schemes of NMDFC
        </h3>
        <ul className="ml-5 list-disc space-y-2 text-[14px] leading-[1.65] text-[#00152f] marker:text-[#123b73]">
          {schemeDetails.map((scheme) => (
            <li key={scheme.label}>
              <span className="font-bold text-[#123b73]">{scheme.label}</span>{" "}
              {scheme.text}
            </li>
          ))}
        </ul>
      </section>

      <section className="-mx-5 overflow-x-auto px-5 pb-2 md:mx-0 md:px-0">
        <table className="min-w-[960px] table-fixed border-separate border-spacing-0 overflow-hidden rounded-lg bg-white text-[#001b3d]">
          <colgroup>
            <col className="w-[125px]" />
            <col className="w-[125px]" />
            <col className="w-[120px]" />
            <col className="w-[120px]" />
            <col className="w-[120px]" />
            <col className="w-[120px]" />
            <col className="w-[120px]" />
            <col className="w-[135px]" />
          </colgroup>
          <thead>
            <tr>
              <th
                className="relative border border-[#9fc6fb] bg-[#dcecff] p-0 text-[#15356b]"
                colSpan="2"
                rowSpan="2"
                style={{
                  backgroundImage:
                    "linear-gradient(to top right, transparent calc(50% - 1px), #9fc6fb 50%, transparent calc(50% + 1px))",
                }}
              >
                <span className="absolute right-7 top-5 text-[13px] font-bold">
                  Schemes &rarr;
                </span>
                <span className="absolute bottom-5 left-4 text-[13px] font-bold">
                  Particulars &darr;
                </span>
              </th>
              <th className={headerCellClass} rowSpan="2">
                Term Loan
              </th>
              <th className={headerCellClass} rowSpan="2">
                Virasat
              </th>
              <th className={headerCellClass} colSpan="2">
                Education Loan
              </th>
              <th className={headerCellClass} colSpan="2">
                Micro Finance Loan
              </th>
            </tr>
            <tr>
              <th className={headerCellClass}>Domestic Courses</th>
              <th className={headerCellClass}>Foreign Courses</th>
              <th className={headerCellClass}>Individually</th>
              <th className={headerCellClass}>SHG (Upto 20 Members)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={labelCellClass} rowSpan="2">
                <span className="block underline">Credit Line-1</span>
                <span className="mt-3 block text-[10px] font-semibold leading-[1.35]">
                  (Income level of Rs. 1,20,000/- for Urban areas & Rs.
                  98,000/- for rural areas)
                </span>
              </td>
              <td className={labelCellClass}>Max credit upto</td>
              <td className={textCellClass}>Rs. 20.00 Lakhs</td>
              <td className={textCellClass}>Rs. 10.00 Lakhs</td>
              <td className={textCellClass}>Rs. 20.00 Lakhs</td>
              <td className={textCellClass}>Rs. 30.00 Lakhs</td>
              <td className={textCellClass}>Rs. 1.00 Lakhs</td>
              <td className={textCellClass}>Rs. 20.00 Lakhs</td>
            </tr>
            <tr>
              <td className={labelCellClass}>
                Rate of Interest p.a. for beneficiary
              </td>
              <td className={textCellClass}>6%</td>
              <td className={textCellClass}>
                <span className="block">5% for males</span>
                <span className="mt-2 block">4% for females</span>
              </td>
              <td className={textCellClass}>3%</td>
              <td className={textCellClass}>3%</td>
              <td className={textCellClass}>7%</td>
              <td className={textCellClass}>7%</td>
            </tr>
            <tr>
              <td className={labelCellClass} rowSpan="2">
                <span className="block underline">Credit Line-2</span>
                <span className="mt-3 block text-[10px] font-semibold leading-[1.35]">
                  (Income level of Rs. 8,00,000/- p.a.)
                </span>
              </td>
              <td className={labelCellClass}>Max credit upto</td>
              <td className={textCellClass}>Rs. 30.00 Lakhs</td>
              <td className={textCellClass}>Rs. 10.00 Lakhs</td>
              <td className={textCellClass}>Rs. 20.00 Lakhs</td>
              <td className={textCellClass}>Rs. 30.00 Lakhs</td>
              <td className={textCellClass}>Rs. 1.00 Lakhs</td>
              <td className={textCellClass}>Rs. 20.00 Lakhs</td>
            </tr>
            <tr>
              <td className={labelCellClass}>Rate of Interest p.a.</td>
              <td className={textCellClass}>6%</td>
              <td className={textCellClass}>
                <span className="block">5% for males</span>
                <span className="mt-2 block">4% for females</span>
              </td>
              <td className={textCellClass}>3%</td>
              <td className={textCellClass}>3%</td>
              <td className={textCellClass}>7%</td>
              <td className={textCellClass}>7%</td>
            </tr>
            <tr>
              <td className={labelCellClass} colSpan="2">
                Moratorium Period (for both Credit lines)
              </td>
              <td className={textCellClass}>6 months</td>
              <td className={textCellClass}>6 months</td>
              <td className={textCellClass} colSpan="2">
                6 months after course completion or getting job, whichever is
                earlier
              </td>
              <td className={textCellClass} colSpan="2">
                3 months
              </td>
            </tr>
            <tr>
              <td className={labelCellClass} colSpan="2">
                Repayment Period (for both Credit lines)
              </td>
              <td className={textCellClass}>5 years</td>
              <td className={textCellClass}>5 years</td>
              <td className={textCellClass} colSpan="2">
                5 years
              </td>
              <td className={textCellClass} colSpan="2">
                3 years
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  );
};

export default NmdfcSchemesContent;
